import { useSnackbar } from 'notistack';
import React, { useEffect, lazy, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, getSliderProducts } from '../../actions/productAction';
import MetaData from '../Layouts/MetaData';

// Lazy-load the components
const Banner = lazy(() => import('./Banner/Banner'));
const ProductList = lazy(() => import('./Products/ProductList'));

const Home = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { error, loading } = useSelector((state) => state.products);

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error, { variant: "error" });
      dispatch(clearErrors());
    }
    dispatch(getSliderProducts());
  }, [dispatch, error, enqueueSnackbar]);

  return (
    <>
      {/* Meta Tags for SEO */}
      <MetaData
        title="Ladies Fashion Online – Trendy Styles, Dresses, Tops, and More"
        description="Shop the latest in ladies' fashion with a stunning collection of dresses, tops, skirts, jackets, and accessories. Explore new arrivals, top trends, and exclusive offers!"
        keywords="ladies fashion, women's clothing, trendy dresses, stylish tops, skirts, women's fashion trends, fashion accessories, summer fashion, casual wear, evening wear"
        author="Your Fashion Brand"
        robots="index, follow"
        canonical="https://www.siddhicreatives.com"
      />

      {/* Main Content Area */}
      <main className="flex flex-col gap-3 px-2 mt-20">
        {/* Lazy-loaded Banner */}
        <Suspense fallback={<div>Loading...</div>}>
          <Banner />
        </Suspense>

        {/* Lazy-loaded Product List */}
        <Suspense fallback={<div>Loading...</div>}>
          {!loading && <ProductList title={"Newest Arrivals"} tagline={"Curated Based on Your Interests"} />}
        </Suspense>
      </main>
    </>
  );
};

export default Home;
